import { render, staticRenderFns } from "./TransactionConfirmation.vue?vue&type=template&id=9cd04f48&"
import script from "./TransactionConfirmation.vue?vue&type=script&lang=js&"
export * from "./TransactionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TransactionConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports